import React from "react";

import Image from "next/image";
import { GroqImage } from "@/helpers/Image";

import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";

import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";

import arrowDown from "@/public/manifesto/arrow-down-icon.svg";

export default function Philosofy({ data }: { data: PageManifestoSchema }) {
  return (
    <section className="pt-[2rem] lg:pt-[10rem] pb-[4rem] lg:pb-[9rem] overflow-clip">
      <div className="w-full max-w-[111rem] mx-auto px-[2rem] lg:px-0">
        {/*  */}
        <div className="w-full relative border-b-[.75rem] border-b-[#D9F9B9]">
          <GroqImage
            src={data?.philosofyImage}
            alt="Philosofy image"
            className="w-full min-h-[40rem] object-cover object-left"
          />
          {/*  */}
          <div className="w-fit absolute bottom-0 left-0">
            <div className="w-fit flex justify-center items-center gap-[2rem] px-[4rem] pb-[1.5rem] pt-[2rem] bg-[#D9F9B9] relative">
              {/* right bottom border */}
              <div
                className="absolute top-0 right-[-2.5rem] w-[5rem] h-full bg-[#D9F9B9]"
                style={{
                  clipPath: "polygon(50% 0%, 100% 50%, 100% 100%, 0 100%, 0 0)",
                }}
              ></div>
              {/* end right bottom border */}
              <Image
                src={arrowDown}
                alt="Arrow down"
                className="w-[2rem] min-w-[2rem]"
              />
              <span className="text-black text-[2rem] font-[400] leading-[100%] uppercase">
                {data?.settings?.language === "en"
                  ? "Our Philosophy"
                  : "Unsere Philosophie"}
              </span>
            </div>
          </div>
          {/*  */}
        </div>

        <div className="w-full bg-white p-[3rem] lg:p-[7rem]">
          {data?.philosofyTexts && (
            <PortableText
              value={data?.philosofyTexts ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="font-funnel text-black text-[4.5rem] lg:text-[6rem] leading-[100%] font-[500] mb-[2rem]">
                      {children}
                    </h2>
                  ),
                  normal: ({ children }) => (
                    <p className="text-black/60 font-[400] leading-[150%] mb-0 text-[2.25rem]">
                      {children}
                    </p>
                  ),
                },
                marks: {
                  strong: ({ children }) => (
                    <hr className="w-full mx-auto border-black/10 my-[2rem] lg:my-[3rem]" />
                  ),
                },
              })}
            />
          )}
        </div>
      </div>
    </section>
  );
}
